"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Container_1 = require("../Container");
const Typography_1 = require("../Typography");
const SubHeader = ({ title, subTitle, CTA, sx, initialIcon, qaIds }) => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(Container_1.CustomerGrid, { container: true, justifyContent: "space-between", alignItems: "center", sx: sx, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'center' }, children: [initialIcon, (0, jsx_runtime_1.jsxs)(material_1.Grid, { sx: { maxWidth: 'calc(100vw - 190px)' }, children: [(0, jsx_runtime_1.jsx)(Typography_1.default, { typo: "title_md", sx: {
                                    overflowX: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                }, "data-qa-id": qaIds === null || qaIds === void 0 ? void 0 : qaIds.titleId, children: title }), (0, jsx_runtime_1.jsx)(Typography_1.default, { typo: "body_sm", sx: {
                                    color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
                                    overflowX: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                }, "data-qa-id": qaIds === null || qaIds === void 0 ? void 0 : qaIds.subTitleId, children: subTitle })] })] }), (0, jsx_runtime_1.jsx)(material_1.Grid, { children: CTA })] }));
};
exports.default = SubHeader;
